// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-navigation{display:flex;justify-content:flex-end;flex:1;z-index:2}.user-navigation *{box-sizing:border-box}.user-navigation .dropdown{margin:0 8px;border-radius:999px;padding:5px 8px}@media(width <= 450px){.user-navigation{justify-content:end}}", ""]);
// Exports
module.exports = exports;
